// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteSharedPhoneUpsearchModel {
    static getAttributeTypeMap() {
        return SiteSharedPhoneUpsearchModel.attributeTypeMap;
    }
}
SiteSharedPhoneUpsearchModel.discriminator = undefined;
SiteSharedPhoneUpsearchModel.additionalProperties = false;
SiteSharedPhoneUpsearchModel.attributeTypeMap = [
    {
        "name": "phoneId",
        "baseName": "phoneId",
        "type": "number"
    },
    {
        "name": "phoneType",
        "baseName": "phoneType",
        "type": "ContactInfoType"
    },
    {
        "name": "phonePurpose",
        "baseName": "phonePurpose",
        "type": "ContactInfoPurposeType"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "extension",
        "baseName": "extension",
        "type": "string"
    },
    {
        "name": "contactDatePreferenceType",
        "baseName": "contactDatePreferenceType",
        "type": "ContactDatePreferenceType"
    },
    {
        "name": "bestDaysToCall",
        "baseName": "bestDaysToCall",
        "type": "string"
    },
    {
        "name": "contactTimePreferenceType",
        "baseName": "contactTimePreferenceType",
        "type": "ContactTimePreferenceType"
    },
    {
        "name": "bestTimeToCall",
        "baseName": "bestTimeToCall",
        "type": "string"
    },
    {
        "name": "language",
        "baseName": "language",
        "type": "string"
    },
    {
        "name": "timeZone",
        "baseName": "timeZone",
        "type": "string"
    },
];
//# sourceMappingURL=siteSharedPhoneUpsearchModel.js.map